import {
  Alert,
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { AuthContext } from "./AuthContext";
import Loader from "../../component/Loader";
import loginImg from '../../assets/images/locksmith.png'
const Login = () => {
  document.title = "Login";
  const navigate = useNavigate();
  const dispatch = useDispatch();
    const { state } = useLocation();
  const { signIn, isLoading, message } = useContext(AuthContext);
  const [errors, setErrors] = useState({ email: false, password: false });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const handleUserName = (e) => {
    setErrors('');
    setUsername(e.target.value);
  };

  const handlePassword = (e) => {
    setErrors('');
    setPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let error = {};
    if (!username) {
      error.email = true;
    }
    if (!password) {
      error.password = true;
    }
    setErrors(error);
    if (!username || !password) {
      return;
    }
    await signIn(username?.trim(), password?.trim());
    if(state?.token){
      navigate("/events");
    }else{
      navigate("/");
    }
  };
  return (
    <div className="login_container" data-testid="login-container">
      {isLoading && <Loader />}
      <form className="login_form" data-testid="login-form" onSubmit={handleSubmit}>
        <div className="login_header">
          <img src={loginImg} alt="" />
          <h2>Welcome back</h2>
          <p>Please enter details to sign in</p>
        </div>
        <div className="login_input_fields">
          <TextField
            error={errors.email}
            helperText={errors.email ? 'Email is required' : ''}
            className="login-text-input"
            fullWidth
            variant="outlined"
            label="Email"
            inputProps={{ 'data-testid': 'login-email' }}
            onChange={(e) => handleUserName(e)}
          />
          <FormControl
            fullWidth
            className="login-text-input"
            variant="outlined"
            error={errors.password}
          >
            <InputLabel htmlFor="outlined-adornment-password">
              Password
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? "text" : "password"}
              inputProps={{ 'data-testid': 'login-password' }}
              onChange={(e) => handlePassword(e)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    onMouseUp={handleMouseUpPassword}
                    edge="end"
                  >
                    {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Password"
            />
            {errors.password && (
              <FormHelperText sx={{ color: "red" }}>
                {"Password is required"}
              </FormHelperText>
            )}
          </FormControl>
        </div>
        <div className="login_forgot_pass">
          <Link to={"/forgot-password"} data-testid="login-forgot-password">Forgot password?</Link>
        </div>
        <div className="login_btn">
          <Button type="submit" fullWidth variant="contained" data-testid="login-submit">
            Sign in
          </Button>
        </div>
        <br/>
        <div className="login_privacy_policy">
          <p>By signing up, you agree to the Sportmingle <Link to={'https://sportmingle.com/terms_and_conditions.html'}>Term of Services</Link> and <Link to={'https://sportmingle.com/privacy_policy.html'}>Privacy Policy</Link></p>
        </div>
        <div className="login_create_account">
          <p>
            Don't have an account? <Link to={'/account-type'} data-testid="login-create-account">Create an account</Link>
          </p>
        </div>
      </form>
    </div>
  );
};

export default Login;